/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Ups_Auth_RequiredInputs */

const en_orders_ups_auth_required = /** @type {(inputs: Orders_Ups_Auth_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must be logged in to book UPS shipments`)
};

const es_orders_ups_auth_required = /** @type {(inputs: Orders_Ups_Auth_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes iniciar sesion para reservar envios UPS`)
};

/**
* | output |
* | --- |
* | "You must be logged in to book UPS shipments" |
*
* @param {Orders_Ups_Auth_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_ups_auth_required = /** @type {((inputs?: Orders_Ups_Auth_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Ups_Auth_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_ups_auth_required(inputs)
	return es_orders_ups_auth_required(inputs)
});